/**
 * Audit Service
 * Handles audit history-related API calls
 */
import BaseApiService from '../base/BaseApiService';
import type { AuditHistoryEntry, NoteEntityType } from '@app-types';
import { localDateStartToUTC, localDateEndToUTC } from '@utils/dateUtils';

class AuditService extends BaseApiService {
  /**
   * Get audit history for an entity
   */
  async getAuditHistory(entityType: NoteEntityType, entityId: number): Promise<AuditHistoryEntry[]> {
    return this.get<AuditHistoryEntry[]>(`/audit/${entityType}/${entityId}`);
  }

  /**
   * Generate and download audit log as .xlsx file
   * @param startDate - Local calendar day (YYYY-MM-DD), included from its start
   * @param endDate - Local calendar day (YYYY-MM-DD), included through its end
   */
  async exportAuditLog(startDate: string, endDate: string): Promise<void> {
    // Send the user's calendar days as exact UTC instants so the backend range
    // matches what was picked regardless of timezone (bug #1128).
    const blob = await this.getBlob('/audit/export', {
      startDate: localDateStartToUTC(startDate),
      endDate: localDateEndToUTC(endDate)
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const date = new Date().toISOString().split('T')[0];
    link.download = `audit-log-${date}.xlsx`;

    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }
}

export const auditService = new AuditService();
export default auditService;
